import _ from 'lodash';
import moment from 'moment';
//import async from 'async';
/** @namespace async.waterfall **/
import { apiFetch } from '../utility';

const LATEST_GAS_BUDDY = 'reports/gasBuddy/LATEST/';
const LATEST_IGNORED_GAS_BUDDY = 'reports/gasBuddy/LATEST_IGNORED/';
const GET_RECENT_GAS_BUDDY = 'reports/gasBuddy/GET_RECENT/';
const HISTORICAL_GAS_BUDDY = 'reports/gasBuddy/HISTORICAL';

const initialState = {
	latestForEachStation: undefined,
	latestGasBuddyPrices: undefined,
	latestIgnoredGasBuddyPrices: undefined,
	historicalByStationId: {},
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LATEST_GAS_BUDDY:
			return {
				...state,
				latestGasBuddyPrices: action.gasBuddyPrices,
			};

		case LATEST_IGNORED_GAS_BUDDY:
			return {
				...state,
				latestIgnoredGasBuddyPrices: action.gasBuddyPrices,
			};

		case GET_RECENT_GAS_BUDDY:
			return {
				...state,
				latestForEachStation: action.latestForEachStation,
				stationIdsWithoutLatestPrice: action.stationIdsWithoutLatestPrice,
				maxStaleDays: action.maxStaleDays,
			};

		case HISTORICAL_GAS_BUDDY:
			return {
				...state,
				historicalByStationId: {
					[action.stationId]: action.gasBuddyPricesWithMargin,
				},
			};
		default:
			return state;
	}
};

export const getLatestGasBuddyPrices = ({ callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: 'gasBuddyPrice.search',
			params: {},
			dispatch,
			callback: (err, r) => {
				const gasBuddyPrices = _.get(r, ['collections', 'gasBuddyPriceCollection']);
				dispatch({
					type: LATEST_GAS_BUDDY,
					gasBuddyPrices,
				});
				callback(err);
			},
		});
	};
};

export const getLatestLockedOutGasBuddyPrices = ({ callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: 'gasBuddyPrice.search',
			params: {
				isLockedOut: true,
			},
			dispatch,
			callback: (err, r) => {
				const gasBuddyPrices = _.get(r, ['collections', 'gasBuddyPriceCollection']);
				dispatch({
					type: LATEST_IGNORED_GAS_BUDDY,
					gasBuddyPrices,
				});
				callback(err);
			},
		});
	};
};

export const getRecentGasBuddyPrices = ({ callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			//	method: 'gasBuddyPrice.getRecent',
			method: 'retailPrice.getRecentPricingWithMargins',
			params: {},
			dispatch,
			callback: (err, r) => {
				dispatch({
					type: GET_RECENT_GAS_BUDDY,
					latestForEachStation: r.latestForEachStation,
					stationIdsWithoutLatestPrice: r.stationIdsWithoutLatestPrice,
					maxStaleDays: r.maxStaleDays,
				});
				callback(err);
			},
		});
	};
};

export const getHistoricalGasBuddyPrices = ({ stationId, callback = _.noop }) => {
	return (dispatch) => {
		//- Get last 30 days for a station
		const before = moment();
		const after = moment(before).subtract(60, 'days');

		const params = {
			stationIds: [stationId],
			beforeDate: before.utc().format('YYYY-MM-DD'),
			afterDate: after.utc().format('YYYY-MM-DD'),
		};

		apiFetch({
			method: 'gasBuddyPrice.searchPricesWithMargins',
			params,
			dispatch,
			callback: (err, r) => {
				const gasBuddyPricesWithMargin = r.gasBuddyPricesWithMargin;
				dispatch({
					type: HISTORICAL_GAS_BUDDY,
					stationId,
					gasBuddyPricesWithMargin,
				});
				callback();
			},
		});
	};
};

export const add = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `gasBuddyPrice.add`,
			listNameToUpdate: 'gasBuddyPriceIds',
			params,
			dispatch,
			callback,
			successMessage: `Retail price added successfully.`,
		});
	};
};

export const update = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `gasBuddyPrice.update`,
			listNameToUpdate: 'gasBuddyPriceIds',
			params,
			dispatch,
			callback,
			successMessage: `Retail price updated successfully.`,
		});
	};
};

export const bulkAdd = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `gasBuddyPrice.bulkAdd`,
			params,
			dispatch,
			savingMessage: `Saving retail prices...`,
			successMessage: `Retail prices added successfully.`,
			onSuccessRedirectTo: () => {
				window.location.reload();
			},
			callback,
		});
	};
};
